import { render } from "./CheckSFZ.vue?vue&type=template&id=1ef82192"
import script from "./CheckSFZ.vue?vue&type=script&lang=js"
export * from "./CheckSFZ.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Samples\\学习\\WebPackTest\\my-diary\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__